import { createLazyResource, createMutation } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { companySettingsRepo } from '~/repositories/settings/companySettingsRepository';
import type { CompanySettings } from '~/swagger/settings/Api';
export const [CompanySettingsProvider, useCompanySettings] = createMagicDoorContext('CompanySettings', () => {
  const [companySettings, companySettingsActions] = createLazyResource(() => companySettingsRepo.getCompanySettings());
  const changeCompanySettings = createMutation(async (payload: Partial<CompanySettings>) => {
    await companySettingsRepo.changeCompanySettings({
      ...companySettings(),
      ...payload,
    });

    companySettingsActions.refetch();
  });

  return {
    changeCompanySettings,
    companySettings,
    companySettingsActions,
  };
});
